export default Object.freeze({
  BECA: 140,
  NO_ES_NECESARIO: 261,
  PORTEADOR: 141,
  REGULAR: 139,
});
